import {
  Divider,
  List,
  ListItem,
  ListItemText,
  SxProps,
  Theme,
} from '@mui/material'
import { DynamicContent } from 'shared/components'
import { ExtendedOption } from 'shared/types'
import {
  Container,
  PaginationWrapper,
  BottomButtonWrapper,
  SearchWrapper,
  ListWrapper,
} from './OptionsList.style'
import { Fragment } from 'react'

interface OptionsListProps<T, K> {
  options: ExtendedOption<T, K>[]
  loading: boolean
  PaginationComponent?: React.ReactNode
  SearchComponent?: React.ReactNode
  BottomButtonComponent?: React.ReactNode
  actionsComponent?: (option: ExtendedOption<T, K>) => React.ReactNode
  listItemTextSx?: SxProps<Theme>
   listWrapperSx?: SxProps<Theme>
}

const OptionsList = <T, K>({
  options,
  loading,
  PaginationComponent,
  SearchComponent,
  BottomButtonComponent,
  actionsComponent,
  listItemTextSx,
  listWrapperSx,
}: OptionsListProps<T, K>) => {
  return (
    <Container container options={options?.length > 0}>
      {SearchComponent && <SearchWrapper item>{SearchComponent}</SearchWrapper>}
      <ListWrapper
        item
        className="options-list-wrapper"
        sx={listWrapperSx}
      >
        <DynamicContent
          loading={loading && options.length === 0}
          displayContent={options.length}
          loaderSize={75}
        >
          <List disablePadding>
            {options.map(option => (
              <Fragment key={`option-item-${option.value}`}>
                <ListItem
                  key={`list-item-${option.value}`}
                  sx={{ gap: { xs: 1, md: 0 } }}
                >
                  <ListItemText
                    primary={option.title}
                    secondary={option.subtitle}
                    sx={{ minWidth: 'fit-content', ...listItemTextSx }}
                  />
                  {actionsComponent && actionsComponent(option)}
                </ListItem>
                {options.at(-1)?.value !== option.value && <Divider />}
              </Fragment>
            ))}
          </List>
        </DynamicContent>
      </ListWrapper>
      {PaginationComponent && (
        <PaginationWrapper item>{PaginationComponent}</PaginationWrapper>
      )}
      {BottomButtonComponent && (
        <BottomButtonWrapper>{BottomButtonComponent}</BottomButtonWrapper>
      )}
    </Container>
  )
}

export default OptionsList
